import { Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { getCollectionCategoryData } from "../Category/API/api";
import { Card } from "components/ui";
import { useGlobalContext } from "context/GlobalContext";
import { useNavigate, useParams } from "react-router-dom";
import SortContext from "context/SortContext";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { useGetPurchaseCollectionCategory } from "./API/api";

function CollectionCategoryPurchase({ collection }) {
  const { clientId } = useParams();
  const [collectionCategories, setCollectionCategories] = useState([]);

  let navigate = useNavigate();
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchResultCount, setSearchSuffix, dynamicfilterCount, filterChangeCount, filterChangeDesignCount } =
    useGlobalContext();
  const { setSortOptions } = useContext(SortContext);

  //API
  let payload = {
    clientCode: clientId,
    collectionName: collection,
  };

  const { data, isLoding, error } = useGetPurchaseCollectionCategory(payload);

  useEffect(() => {
    if (data) {
      setCollectionCategories(data?.data);
    }
  }, [data]);

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.totalCount);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
    }
    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [collectionCategories]);

  useEffect(() => {
    setSortOptions(["d", "e", "f"]);
    return () => {
      setSortOptions([]);
    };
  }, []);

  const handleCollectionClick = (collectionCatgeoryName) => {
    navigate(`${encodeURIComponent(collectionCatgeoryName)}`);
  };

  if (isLoding) {
    return <LoadingSmallCard count={20} />;
  }

  if (error) {
    return <p>Error</p>;
  }

  return (
    <div style={{ color: "yellow" }}>
      <Grid container className="Grid-padding" direction="row" sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}>
        {collectionCategories?.map((collection) => {
          return (
            <Grid item onClick={() => handleCollectionClick(collection.category)}>
              <Card
                style={{
                  minWidth: "290px",
                  maxWidth: "290px",
                  height: 62,
                  borderRadius: "5px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {collection.category}
                </Typography>
                <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {collection.count}
                </Typography>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default CollectionCategoryPurchase;
